import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, Banknote, CircleCheckBig, ShieldCheck, Globe2, ScanLine } from 'lucide-react';
import { hostCardStyle } from '../../components/HostSettingsCard';
import { RouteTransitionLogo } from '../../components/RouteTransitionLogo';
import { useBackTarget } from '../../hooks/useBackTarget';

const font = "'Inria Serif', serif";
const infoCardStyle = {
  ...hostCardStyle,
  width: '100%',
  maxWidth: 360,
  padding: '16px 16px',
  boxSizing: 'border-box',
};

const infoItems = [
  {
    id: 'create',
    title: 'Create your account in minutes',
    description: 'No technical setup or extra hardware required',
    Icon: CircleCheckBig,
  },
  {
    id: 'instant',
    title: 'Get paid instantly',
    description: 'Funds go directly to your bank account after each transaction',
    Icon: Banknote,
  },
  {
    id: 'secure',
    title: 'Secure & compliant payments',
    description: 'Handled by a licensed European payment provider',
    Icon: ShieldCheck,
  },
  {
    id: 'trusted',
    title: 'Trusted across Europe',
    description: 'Used by thousands of businesses daily',
    Icon: Globe2,
  },
  {
    id: 'staff',
    title: 'Simple for your staff',
    description: 'Enter amount → scan QR → get paid',
    Icon: ScanLine,
  },
];

export default function VenueVivaInfoPage() {
  const navigate = useNavigate();
  const goBack = useBackTarget();

  return (
    <div className="app-shell" data-testid="venue-viva-info-page" style={{ minHeight: '100vh', backgroundColor: 'var(--app-bg)', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingBottom: 40 }}>
      <div style={{ width: '100%', maxWidth: 390, display: 'flex', justifyContent: 'flex-start', padding: '16px 20px 0' }}>
        <button data-testid="venue-viva-info-back-button" onClick={goBack} style={{ background: 'none', border: 'none', cursor: 'pointer' }}><ChevronLeft size={30} color="#000" strokeWidth={2} /></button>
      </div>

      <div style={{ marginTop: 8 }}>
        <RouteTransitionLogo width={100} height={89} dataTestId="venue-viva-info-shared-logo" />
      </div>
      <h2 style={{ fontFamily: font, fontSize: 26, fontWeight: 700, color: 'var(--text)', marginTop: 8, marginBottom: 18, textAlign: 'center' }}>Why connect with Viva Wallet?</h2>

      <div style={{ width: '100%', maxWidth: 360, padding: '0 16px', display: 'flex', flexDirection: 'column', gap: 12 }}>
        {infoItems.map(({ id, title, description, Icon }) => (
          <div key={id} data-testid={`venue-viva-info-card-${id}`} style={infoCardStyle}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
              <Icon size={24} color="#1F8E2A" style={{ flexShrink: 0, marginTop: 2 }} />
              <div>
                <p style={{ fontFamily: font, fontSize: 22, fontWeight: 700, color: 'var(--text)', margin: 0, lineHeight: 1.05 }}>{title}</p>
                <p style={{ fontFamily: font, fontSize: 17, color: 'var(--text)', margin: '6px 0 0', lineHeight: 1.1 }}>{description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}